import { FormHelperText, Select, Tooltip, Typography, styled } from "@mui/material";

import { ArrowDropDown } from "@mui/icons-material";

import { FreebieRuleStatus, FreebieRuleType } from "../../../utils/enums";

export const SectionTitle = styled(Typography)`
    font-size: 18px;
    font-weight: 500;
    color: #626262;
`;

export const Row = styled("div")`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};

    width: 100%;

    ${({ theme }) => `
    ${theme.breakpoints.down("md")} {
          flex-direction: column;
    }
  `}
`;

export const TextFieldContainer = styled("div")`
    height: 55px;
    flex: 1;

    ${({ theme }) => `
    ${theme.breakpoints.down("md")} {
        width: 100%;
    }
  `}
`;

export const SelectField = styled(Select)`
    height: 40px;
`;

export const ErrorMessage = styled(FormHelperText)`
    padding: ${({ theme }) => theme.spacing(1)};
    color: red;
`;

export const RadioErrorMessage = styled(FormHelperText)`
    color: red;
    margin-left: 30px;
`;

export const StyledTooltip = styled(Tooltip)`
    cursor: default;
`;

export const StyledArrowDown = styled(ArrowDropDown)`
    margin-right: ${({ theme }) => theme.spacing(3)};
`;

export const FreebieRuleSection = styled("section")`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(2)};
`;

export const SectionTitleContainer = styled("div")`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};
`;

export interface IFreebieRuleForm {
    name: string;
    type: FreebieRuleType;
    status: FreebieRuleStatus;
    priority: number;
    minCartValue: string;
    discountCode: string;
    quantity: number;
    triggerVariantIds: string[];
    freebieVariantIds: string[];
}

export const disableScrollWheelInput = (
    event: React.WheelEvent<HTMLDivElement>,
) => {
    event.currentTarget.querySelector("input")?.blur();
};
